import { citiesStore } from './model';
import { SELECT_FLEET, SET_CITIES } from './constants';

export function citiesReducer(state = citiesStore, action) {
    switch (action.type) {
        case SET_CITIES:
            return {
                ...state,
                list: action.payload,
            };

        case SELECT_FLEET:
            return {
                ...state,
                selectedFleet: action.payload,
            };

        default:
            return state;
    }
}
